export const COMPLETED_STATUS = {
  success: 'success',
  technicalFailure: 'technical failure',
  paymentFailure: 'payment failure',
};

export const getPlanChangeCompletedEventStatusFromResponse = (response) => {
  const { success, technicalFailure, paymentFailure } = COMPLETED_STATUS;
  if (response.ok) return success;
  if (response.status === 422) return paymentFailure;
  return technicalFailure;
};
